// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.col-gc20 {
  width: 20%;
  padding: 0.5rem;
}

.gc-agency-handle {
  width: 160px;
}

.col-gc15 {
  width: 15%;
  padding: 0.5rem;
}

.col-gc25 {
  width: 25%;
  padding: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/app/visit/visit.component.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,eAAA;AACF;;AACA;EACI,YAAA;AAEJ;;AACA;EACE,UAAA;EACA,eAAA;AAEF;;AACA;EACE,UAAA;EACA,eAAA;AAEF","sourcesContent":[".col-gc20{\n  width: 20%;\n  padding: 0.5rem;\n}\n.gc-agency-handle{\n    width: 160px;\n}\n\n.col-gc15{\n  width: 15%;\n  padding: 0.5rem;\n}\n\n.col-gc25{\n  width: 25%;\n  padding: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
